<template>
  <!-- 已弃用 -->
  <!-- <div class="data_up animated fadeInRightBig" @click="courseBlock"> -->
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="$t('courseDataySync.title')"
      placement="top"
    >
      <div
        class="data_up"
        style="z-index: 1;"
        @click="courseBlock"
      >
        <i
          class="icon-18"
          :class="{warmfont:isshow && computedIsshow}"
        />
      </div>
    </el-tooltip>
    <!-- <span>{{$t('courseDataySync.title')}}<em v-if="computedIsshow"
          class="data_dot"></em></span> -->
  </div>
</template>

<script>
import { FindUnSyncCount } from '@/axios/ISyncPanel.js'
import { ShowHistorySyncResult } from '@/axios/IArea.js'
import { ShowIftttHistorySyncResult } from '@/axios/IFttt.js'
import { ShowSceneHistorySyncResult } from '@/axios/IScene.js'
import { FindDeviceSyncResult } from '@/axios/IDevice.js'
export default {
  name: 'DataSync',
  props: ['courseid', 'areaTreeType', 'isDeviece'],
  data() {
    return {
      isshow: false, //是否有数据
      isshowArray: [], //禅道6269-参数下发失败待同步，设备同步图标没有给出同步提示-张成op070278
    }
  },
  computed: {
    computedIsshow() {
      // 所有接口返回时才判断
       if(this.isshowArray.length<4){
        return this.isshow
       }
       const find = this.isshowArray.find((item) => item === true)
       if (find) {
        return true 
       }
       return false
    },
  },
  mounted() {
    this.showdata()
  },
  methods: {
    functionDoFindUnSyncCount(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          var item = rs.Result,
            param = 0
          param += item['AreaCodeCount'] && item['AreaCodeCount']
          param +=
            item['ConstantIlluminationCount'] &&
            item['ConstantIlluminationCount']
          param += item['IFtttCount'] && item['IFtttCount']
          param += item['ProjectCodeCount'] && item['ProjectCodeCount']
          param += item['RhythmSyncCount'] && item['RhythmSyncCount']
          param += item['SceneCount'] && item['SceneCount']
          param += item['SmartConfigsCount'] && item['SmartConfigsCount']

          if (param > 0) {
            this.isshow = true
          }
          //  else {
          //   this.isshow = false
          // }
          this.isshowArray.push(param > 0)

          // item = null
          // param = null
        }
      }
    },
    functionDoNotice(rs) {
      
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result.length > 0) {
          this.isshow = true
        } 
        // else {
        //   this.isshow = false
        // }
        this.isshowArray.push(rs.Result.length > 0)
      }
    },
    showdata() {
    
      // if (this.courseid != -1){
      var para = this.isDeviece
        ? { vDeviceId: this.courseid }
        : { gpNo: this.courseid }

      // if (this.areaTreeType == 1) {
      //区域
      ShowHistorySyncResult(para, this.functionDoNotice)
      // } else if (this.areaTreeType == 2) {
      //场景
      ShowSceneHistorySyncResult(para, this.functionDoNotice)
      // } else if (this.areaTreeType == 3) {
      //自动化
      ShowIftttHistorySyncResult(para, this.functionDoNotice)
      // } else if (this.areaTreeType == 6) {
      if (this.isDeviece) {
        //参数
        FindDeviceSyncResult(para, this.functionDoNotice)
      } else {
        FindUnSyncCount({ gpNo: this.courseid }, this.functionDoFindUnSyncCount)
      }
      // }
      para = null
      // }
    },
    courseBlock() {
      this.$emit('courseBlock')
    },
    refresh(){
      this.isshowArray = [];
      this.showdata()
    },
  
  },
}
</script>

<style scoped="scoped" lang="scss">
/* 数据同步组件 */
.data_up {
  position: absolute;
  top: -83px;
  right: 20px !important;
  width: 56px;
  height: 56px;
  border-radius: 50% !important;
  background-color: #fff;
  box-shadow: 0px 6px 11px 1px #cbd3e4;
  border-radius: 3px 3px 0px 0px;
  border: solid 1px #e7ecf3;
  line-height: 62px;

  i {
    /*color: $color5;*/
    font-size: 26px;
    vertical-align: sub;
    margin-left: 16px;
    margin-right: 8px;
  }
  span {
    font-size: 16px;
    color: #212121;
  }
}
</style>
